<template>
  <div id="payindex">
    <div class="content">
      <pagehead :userInfo="userInfo || {}" ref="pagehead"></pagehead>
      <div class="fc-pad-b-sm fc-pad-lr fc-space-between fc-mar-t">
        <div class="tab">
          <span class="fc-text-sm fc-color-gray tab_item" :class="{ 'active': tabType == 1 }" @click="tabType = 1">{{ $t('m.payforType') }}</span>
          <span class="splitLine"></span>
          <span class="fc-text-sm fc-color-gray tab_item" :class="{ 'active': tabType == 2 }" @click="tabType = 2">{{ $t('m.reseller') }}</span>
        </div>
        <div class="select-local" @click="showcountryPicker = true" v-if="selCountryInfo.content && tabType == 1" v-cloak>
          <img src="../assets/img/cz_location.png">
          <span>{{ selCountryInfo.content }}</span>
        </div>
      </div>
      <div v-if="tabType == 2">
        <sellers :country="selCountryInfo"></sellers>
      </div>
      <div v-else="tabType==1">

        <van-collapse v-model="activePayIndex" accordion class="payStyleCon" v-if="payStyleArr" @change="changePayType">
          <van-collapse-item :name="index" v-for="(item, index) in payStyleArr" :key="'pay' + index">
            <template #title>
              <div class="fc-flex fc-flex-vcenter">
                <span class="payStyleIcon">
                  <img :src="item.rechargePayType.payTypeImg">
                </span>
                <span class="fc-flex1 fc-text-bigabit">{{ item.rechargePayType.payTypeShowName }}</span>
              </div>
            </template>
            <div class="payTiptxt" v-if="item.rechargePayType.payTypeShowName && item.rechargePayType.payTypeShowName.toLowerCase() == 'razer gold pin'"> {{ $t('m.recharge_tip') }}</div>
            <buy-item v-for="(son, index) in item.rechargeNormList" :key="'paymoney' + index" :payType="item" :normInfo="son" :selCountryInfo="selCountryInfo" :userInfo="userInfo || {}" :domainCountry="domainCountry" :from="from">
            </buy-item>
          </van-collapse-item>
        </van-collapse>
        <div v-else class="nodataImg">
          <img src="../assets/img/nodata.png" alt="">
        </div>
      </div>
      <p v-if="tabType == 1 && !userInfo.userId && !isRealLive()" class="fc-notice" v-html="$t('m.buy-notice-a', {msg: curHost})"></p>
    </div>

    <!-- 常见问题 -->
    <ask v-if="tabType == 1 && !userInfo.userId && !isRealLive()"></ask>
    <van-popup v-model="showIdDesc" closeable overlay-class="fcId_mask" :style="{ width: '6rem', 'max-width': '370px', 'margin-left': '0' }">
      <div class="fc-text-center fc-pad-tb">
        <p class="fc-text-center fc-text-center fc-text-usual">{{ $t('m.openAPP') }}</p>
        <img src="../assets/img/findID.png" width="94%" alt="">
      </div>
    </van-popup>
    <van-popup v-model="showcountryPicker" round position="bottom" @close="closeHandle">
      <van-picker show-toolbar :default-index="currentCountryIndex" :loading="countryLoading" :confirm-button-text="$t('m.trueText')" :cancel-button-text="$t('m.falseText')" :columns="countryArr" value-key="content" @cancel="closeHandle()" @confirm="selCountryConfirm" default-index="0">
        <template #columns-top>
          <div class="searchBox">
            <van-field class="inputContent" v-model="searchValue" @input="searchValueChange" :placeholder="$t('m.placecommen')">
              <template #left-icon>
                <img style="width: 14px;display: flex;justify-content: center;align-items: center;" src="../assets/img/icon_search.png">
              </template>
            </van-field>
          </div>
        </template>
      </van-picker>

      <div class="countryImg" v-if="countryShow">
        <img src="../assets/img/country.png" alt="">
      </div>
    </van-popup>

    <van-overlay :show="isShowWechatPop" v-if="isShowWechatPop">
      <div class="van-dialog" @click.stop style="width: 76%;">
        <div class="wechatPaycon">
          <div>{{ $t('m.wxPay') }}</div>
          <div class="van-hairline--top fc-color-main" @click="completePay(1)">{{ $t('m.Completed') }}</div>
          <div class="van-hairline--top" @click="completePay(2)">{{ $t('m.failedPay') }}</div>
        </div>
      </div>
    </van-overlay>
    <!-- 引导 -->
    <guide :show="isShowGuide" :top="guildeTop" :selCountryInfo="selCountryInfo" @close="isShowGuide = false" ></guide>
  </div>
</template>

<script>
import Vue from 'vue';
import '@vant/touch-emulator';
import sellers from '@/components/sellers'
import buyItem from '@/components/buyItem'
import ask from '@/components/ask'
import pagehead from '@/components/pagehead'
import guide from '@/components/guide'
import {
  Picker,
  Toast,
  Popup,
  Overlay,
  Collapse,
  CollapseItem,
  Dialog,
  Field
} from 'vant';
Vue.use(Picker);
Vue.use(Toast);
Vue.use(Popup);
Vue.use(Overlay);
Vue.use(Collapse);
Vue.use(CollapseItem);
Vue.use(Dialog);
Vue.use(Field);
import { getUserInfoCache, getSysLang, getParamsHash,isSafari } from "@/tools/common.js";
import { getCountryListAjax, getPayChannelsAjax } from "@/api/pay.js";
import {getDukpayRatio,getCountryByIp} from "../api";
import {extractObjParamsExcluding, isRealLive} from "../util";
var _self;
export default {
  name: 'index',
  components: {
    sellers,
    'buy-item': buyItem,
    ask, pagehead, guide
  },
  data() {
    return {
      token: '',
      // userId: '',//2120000508
      showIdDesc: false,//是否显示‘什么是fcid’
      selPayStyleId: null,
      selPayStyleNormId: null,
      currentCountryIndex: 0,
      currentCountry: '', //当前的国家语言
      selCountryInfo: {},
      countryLoading: false, //加载中
      showcountryPicker: false,
      countryArr: [],
      countryArrAll: [],
      countryShow: false,
      payStyleArr: '',
      activePayIndex: null,
      searchValue: null,
      isShowWechatPop: false, //是否显示微信回调弹窗
      tradeNo: '', //订单号

      isShowGuide: false,

      guildeTop: '2.8rem',

      tabType: 1,//1充值方式 2官方币商
      userInfo: localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem('userInfo')) : {},
      defaultCountryCoding: "US",
      initCountry:"",
      domainCountry: null,
      curHost: window.location.host,
      from: null,
    }
  },
  watch: {
    isShowGuide(val) {
      let oDiv = document.getElementsByTagName('body')[0];
      if (val) {
        oDiv.classList.add('van-overflow-hidden')
      } else {
        oDiv.classList.remove('van-overflow-hidden')
      }
    }
  },
  filters: {

  },
  created() {
    // 网页追踪
    // this.$analytics.logEvent('PC_pay', {
    //   'content_type': 'Login_click',
    // });
    this.$analytics.logEvent('PC_pay', {
      'app_name': 'H5充值',
      'screen_name': '充值首页'
    });
    _self = this;
    _self.getUserInfo();
    _self.currentCountry = getSysLang();


    Dialog.setDefaultOptions({
      width: '76%',
      confirmButtonColor: '#008AFF',
      confirmButtonText: _self.$t('m.trueText'),
      cancelButtonText: _self.$t('m.falseText'),
    })

    _self.getCountryList();
    _self.showWechatPopFun();
    _self.getDomainCountry()

  },
  mounted() {
    let paramObj = this.parseQuery()
    console.log("paramObj: ", paramObj)
    if (!this.$globalData.source) {
      this.$globalData.source = getParamsHash('source') || paramObj.source || '';
    }
    if (!this.$globalData.channel) {
      this.$globalData.channel = getParamsHash('channel') || paramObj.channel || '';
    }
    console.log('source: ', this.$globalData.source);
    console.log('channel: ', this.$globalData.channel);
    // this.$globalData.source = getParamsHash('source')||'';
    this.initFrom()

    let isFristEnter = localStorage.getItem('isFristEnter');
    if (isFristEnter == 1) {
      //1已经访问过
    } else {
      this.$nextTick(() => {
        let a = _self.$refs.pagehead;
        console.log(a);
        const h = a.offsetHeight;
        console.log(h);
        _self.guildeTop = h + 'px';
        _self.isShowGuide = true;
      })

    }
  },
  methods: {
    isRealLive,
    parseQuery() {
      var href = window.location.href;
      console.log("parseQuery href: ", href)
      let fromParam = decodeURIComponent(href)
      // 如果链接参数from参数不为空, 则页面重定向到别个一个页面
      // 获取fromParam中[]之间的字符串
      let startIndex = fromParam.indexOf('sd_id')
      let endIndex = fromParam.indexOf('ed_id')
      if (startIndex === -1 || endIndex === -1 || startIndex >= endIndex) {
        return {}
      }
      let url = fromParam.substring(startIndex + 5, endIndex)
      console.log("parseQuery url: " +url)
      return extractObjParamsExcluding(url, null)
    },
    initFrom() {
      let source = this.$globalData.source;
      let channel = this.$globalData.channel;
      console.log('source-channle: ', source, channel)
      if(!(source || (channel && channel === 'huawei_global'))) {
        return
      }
      // 将source和channel拼到链接后面(如果参数存在的话)，作为跳转的参数
      let str = ''
      if(source) {
        str += '&source=' + source;
      }
      if(channel) {
        str += '&channel=' + channel;
      }
      let url = 'sd_id'+window.location.origin + '/#/index?' + str.substring(1)+'ed_id';
      console.log('init from url: ' + url)
      _self.from= encodeURIComponent(url)
    },
    /**
     * 获取域名国家
     * pay.buzzcast.buzz 对应菲律宾PH
     */
    getDomainCountry() {
      let host = window.location.host
      if(host === 'pay.buzzcast.buzz') {
        this.domainCountry = 'PH'
      } else if (host === 'pay.reallive.me'){
        this.domainCountry = 'RealLive'
      }
    },
    closeHandle() {
      _self.showcountryPicker = false;
      _self.searchValue = '';
      _self.countryShow = false;
      _self.countryArr = _self.countryArrAll;
    },
    // 模糊搜索
    searchValueChange(val) {
      if (val) {
        _self.countryArr = _self.countryArrAll.filter((item) => {
          return item.content.toLowerCase().indexOf(val.toLowerCase()) > -1
        })
        _self.countryArr.length == 0 ? _self.countryShow = true : _self.countryShow = false;
      } else {
        _self.countryShow = false;
        _self.countryArr = _self.countryArrAll
      }
      console.log('val', val, _self.countryArr);
    },
    // 埋点加 充值方式点击
    changePayType(e) {
      console.log('e-->', e);
      if (e || e === 0) {
        this.$analytics.logEvent('PC_pay_click', {
          pay_country: _self.selCountryInfo.content,
          paystyle_name: _self.payStyleArr[e].rechargePayType.payTypeShowName,
        })
      }
    },
    //获取RUL参数值
    getUrlParam(fromeType) {
      var params = decodeURI(window.location.search);
      var reg = new RegExp("(^|&)" + fromeType + "=([^&]*)(&|$)");
      var r = params.substr(1).match(reg);
      if (r != null) return unescape(r[2]);
      return null;
    },
    //判断微信显示弹窗
    showWechatPopFun() {
      //判断是否有订单号
      let tradeNo = _self.getUrlParam('tradeNo');
      // console.log(tradeNo);
      let language = navigator.language || navigator.browserLanguage;
      var lang = language.split('-')[0];
      // console.log(lang);
      if (tradeNo) {
        _self.tradeNo = tradeNo;
        var IsWeChatPay = localStorage.getItem("IsWeChatPay");
        // console.log(IsWeChatPay);
        // console.log(lang);
        if (IsWeChatPay == 'true' && lang == 'zh') {
          //Toast('微信支付');
          _self.isShowWechatPop = true;
        }
      } else {
        localStorage.removeItem("IsWeChatPay");
      }
    },

    //缓存读取用户信息
    getUserInfo(e) {
      let info = getUserInfoCache();
      if (info) {
        _self.userInfo = info;
        _self.token = info.token;
        // _self.userId = info.userId;
      } else {
        _self.userInfo = '';
      }
      return;
    },

    selCountryConfirm(val, index) {
      console.log('val', val, index);
      // console.log(val);
      if (val) {
        localStorage.setItem('selCountryInfo', JSON.stringify(val));
        _self.currentCountryIndex = index;
        _self.selCountryInfo = val;
        _self.activePayIndex = null;
        _self.showcountryPicker = false;
        _self.getPayChannels(val.countryId);
      } else {
        console.log('请选择数据');
      }
    },

    //获取当前地区
    getCountryList() {
      Toast.loading({
        duration: 0, // 持续展示 toast
        forbidClick: true,
        icon: require('../assets/img/loading.gif'),
        className: 'loading'
      });
      _self.countryLoading = false;
      getCountryListAjax(_self.currentCountry).then((res) => {
        _self.countryLoading = false;
        // console.log(list)
        if (res.data.code == 1) {
          try {
            let list = res.data.result;
            list = list.filter(item => {
              return item.coding !== 'CN' && item.coding !== 'TW' && item.coding !== 'HK';
            })
            _self.countryArr = list;
            _self.countryArrAll = list;
            _self.pipeiCountry(list);
          } catch (error) {
            console.log(error + '')
            Toast(error + '');
          }
        } else {
          Toast(res.msg)
        }
      }).catch((error) => {
        console.log(error);
        Toast(error.message);
        // Toast('getCountryList Ajax error!')
      })
    },
    pipeiCountry(arr) {
      let getInfo = localStorage.getItem('selCountryInfo');
      let cunCountryInfo = JSON.parse(getInfo);
      // console.log(cunCountryInfo);
      let coding = '';
      if (cunCountryInfo && cunCountryInfo.coding) {
        coding = cunCountryInfo.coding;
      }
      // 判断是否匹配到用户当前国家，否则默认选美国
      let findItemIndex = arr.findIndex(e => e.coding == coding);
      getCountryByIp().then((res) => {
        if(res.data.code === 1){
          if (findItemIndex < 0) {
            findItemIndex = arr.findIndex(e => e.coding == res.data.result);
          }
          _self.pipeiFilter(arr,findItemIndex)
        }
      }).catch(err => {
        _self.pipeiFilter(arr,findItemIndex)
      })

    },
    pipeiFilter(arr, findIndex){
      let findItem = findIndex
      if(findItem < 0){
        findItem = arr.findIndex(e => e.coding == _self.defaultCountryCoding)
      }
      if(findItem < 0) {
        Toast.clear();
        return
      }
      _self.currentCountryIndex = findItem;
      _self.selCountryInfo = arr[findItem];
      _self.getPayChannels(_self.selCountryInfo.countryId);
    },
    /**
     * 获取dukpay美元和本地货币的转换汇率
     * @returns {Promise<unknown>}
     */
    async getDukpayRate() {
      return new Promise((resolve) => {
        getDukpayRatio(this.selCountryInfo.countryId).then(({data}) => {
          if(data && data.data && data.data.rate) {
            resolve(data.data.rate)
          } else {
            resolve(null)
          }
        }).catch(() => {
            resolve(null)
        })
      })
    },
    // 获取单个国家下面的支付方法有哪些
    async getPayChannels(countryId) {
      let cityID;
      if (countryId) {
        cityID = countryId
      } else {
        cityID = _self.countryArr[_self.currentCountryIndex].countryId;
      }
      Toast.loading({
        duration: 0, // 持续展示 toast
        forbidClick: true,
        icon: require("../assets/img/loading.gif"),
        className: 'loading'
      });

      let hidePayName = []
      if(!isSafari()){
        hidePayName.push('ApplePay')
      }
      let countryCode = _self.selCountryInfo.coding
      // 美元和duckpay的汇率
      let dukpayRate
      if(countryCode === 'EG' || countryCode === 'RU') {
        dukpayRate = await this.getDukpayRate()
      }
      getPayChannelsAjax({
        "countryId": cityID,
        "language": _self.currentCountry,
        "systoken": _self.token,
        "hidePayName": hidePayName.toString()
      }).then((res) => {
        Toast.clear();
        if(dukpayRate) {
          res.data.result.forEach(item => {
            item.dukpayRate = dukpayRate
          })
        }
        // 获取链接中的参数channel,华为渠道包隐藏dpay支付方式
        let channel = _self.$globalData.channel;
        if(channel && channel === 'huawei_global') {
          const dpayIndex = res.data.result.findIndex(item => item.rechargePayType && item.rechargePayType.payTypeAgentCode === 'dpay')
          if(dpayIndex > -1) {
            res.data.result.splice(dpayIndex, 1);
          }
        }
        // 获取source
        // 安卓渠道隐藏所有的paypal
        let source = this.$globalData.source
        let arr = res.data.result || []
        if(source && source.trim().toLowerCase() === 'android') {
          arr = arr.filter(payInfo => {
            let info = payInfo.rechargePayType
            return !(info && ([3, 10075, 10076, 10078].includes(info.id) || (info.aggregatePay === 11 && info.payTypeAgentCode === "paypal")))
          })
        }
        _self.payStyleArr = arr;
        if (res.data.code == -1) {
          _self.userInfo = '';
          localStorage.setItem("userInfo", '');
        }
        let rechargeArr = JSON.parse(JSON.stringify(_self.payStyleArr));
        // google 充值方式，放到第一位
        /* rechargeArr.find((e, i) => {
          if (e.rechargePayType.payTypeName == "GooglePayTop") {
            rechargeArr.splice(i, 1);
            rechargeArr.unshift(e);
            // rechargeArr.push(e);
            return e;
          }
        }) */
        // Apple Pay 排到第4位
        rechargeArr.find((e, i) => {
          if (e.rechargePayType.payTypeName == "ApplePay") {
            if(!isSafari()){
              // rechargeArr.splice(3, 0, e);
              rechargeArr.splice(i, 1);
            }
            return e;
          }
        })
        _self.payStyleArr = rechargeArr;

      }).catch((error) => {
        console.log(error) //  错误处理 相当于error
        Toast(error.message);
        // Toast('getPayChannels Ajax error!')
      })
    },
    //微信用，确认是否支付完成
    completePay(e) {
      //e==1 已完成支付 2支付遇到问题
      localStorage.removeItem("IsWeChatPay");
      let param = {
        "tradeNo": _self.tradeNo,
        "systoken": _self.token
      };

      Toast.loading({
        duration: 0, // 持续展示 toast
        forbidClick: true,
        icon: require("../assets/img/loading.gif"),
        className: 'loading'
      });
      this.$axios({
        method: "post",
        url: "/web/h5/pay/alreadyPay",
        params: {
          "param": JSON.stringify(param)
        },
      }).then((res) => {
        _self.isShowWechatPop = false;
        // console.log(res.data);
        if (res.data.code == 1) {
          var tradeNo = res.data.result.tradeNo;
          var alreadyPay = res.data.result.alreadyPay;
          //e==1 已完成支付 2支付遇到问题
          if (e == 1) {
            if (alreadyPay == 1) {
              _self.$router.push({
                path: '/success'
              })
            } else {
              Toast({
                message: _self.$t('m.toastTips-no-complete'),
                duration: 3000
              });
            }
          } else {
            if (alreadyPay == 1) {
              _self.$router.push({
                path: '/success'
              })

            } else if (alreadyPay == 0) {
              //跳转第三方
              window.location.href = _self.global_apiUrl + "/web/h5/pay/start?tradeNo=" + tradeNo;
            }
          }
        } else {
          Toast(res.data.msg);

        }
      }).catch((error) => {
        // console.log(error) //  错误处理 相当于error
        // Toast(JSON.stringify(error));
        Toast(error.message);
      })
    }

  },

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.countryImg {
  position: absolute;
  bottom: 0px;
  left: 0px;
  width: 100%;
  height: 240px;
  background: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 999;
  pointer-events: none;
}

.countryImg img {
  width: 30%;
}

.nodataImg {
  width: 100%;
  display: flex;
  justify-content: center;
}

.nodataImg img {
  width: 30%;
}

.payTiptxt {
  color: #999;
  font-size: .24rem;
  padding-top: .3rem;
}

.searchBox {
  width: 100%;
  display: flex;
  justify-content: center;

}

.inputContent {
  width: 90%;
  background: #f2f2f2;
  padding: 7px 16px !important;
  border-radius: 5px;
}

.splitLine {
  width: 1px;
  height: 1em;
  background-color: #aaa;
  margin: 0 .1rem;
}

.tab {
  display: flex;
  align-items: center;
}

.tab_item {
  cursor: pointer;
}

.tab .active {
  color: #008AFF;
}

.avater {
  flex-shrink: 0;
}
</style>



// WEBPACK FOOTER //
// src/pages/index.vue